<div class="wrapper">
  <div class="nav mr-3 wrapper-close">
    <button
      type="button"
      (click)="closeMe()"
      class="close text-light"
      aria-label="Close"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="text-center scroll help-container">
    <div class="mt-5">
      <img
        class="img-medium"
        src="./assets/images/help-icons/swipe_help.png"
        alt=""
      />
      <span class="ml-3 align-middle">
        <div>
          Arrastra el dedo para mirar alrededor
          <span class="d-block">
            <small>(Click + arrastrar con mouse)</small>
          </span>
        </div>
      </span>
    </div>

    <div class="mt-5">
      <img
        *ngIf="movementType === 'pin'"
        class="img-large"
        src="./assets/images/icons/pin.png"
        alt=""
      />
      <img
        *ngIf="movementType === 'arrow'"
        class="img-large"
        src="./assets/images/icons/arrow.png"
        alt=""
      />
      <span class="ml-3 align-middle">
        <div>Toca los íconos para moverte por el espacio</div>
      </span>
    </div>

    <div class="mt-5">
      <img
        class="img-small"
        src="./assets/images/icons/button.png"
        alt=""
      />
      <span class="ml-3 align-middle">
        <div>Toca los botones para inspeccionar un producto</div>
      </span>
    </div>
    <div class="mt-5">
      <button (click)="closeMe()" class="btn btn-custom">Entendido</button>
    </div>
  </div>
</div>
